
<template>
    <!-- 刷卡记录表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="刷卡日期">
            <el-date-picker
               v-model="dayStr"
               type="date"
               placeholder="请选择日期"
               value-format="yyyy-MM-dd"
               format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              plain
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column prop="oldName" label="老人姓名"  align=center></el-table-column>
            <el-table-column prop="oldIdcard" label="身份证号码" align=center></el-table-column>
            <el-table-column prop="location" label="位置" align=center></el-table-column>
            <el-table-column prop="createdTime" label="刷卡时间" align=center></el-table-column>
            <el-table-column prop="picture" label="照片" align=center></el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber:0,
        loading:true,
        dayStr:"",
        filteForm: {
          type: "",
          name:""
        },
        tableData:[],
        typeList:[],
      };
    },
    methods: {
      //点击查询
      onSubmit() {
        this.pageNum = 1;
        this.getTableData();
      },
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let params = {
          groupId:this.groupId,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          dayStr:this.dayStr
        };
        this.loading = true;
        this.$postJson('omc/swipeCard/selectByDay',params).then(res=>{
          if(res.code==200){
            this.totalDataNumber = Number(res.result.total)
            this.tableData = res.result.list;
          }
          this.loading = false;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
      
    },
    mounted() {
      this.getTableData();
    },
    created(){
      this.groupId = sessionStorage.getItem("groupId");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  </style>